export class EmployeeData{
    Id:any;
    UserName:any;
    UserId:any;
    EmailAddress:any;
    EmpId:any;
    StatusId:any;
    IsActive:any;
    LastWorkingDate: string;
}